
import { Options, Prop, Vue } from 'vue-property-decorator';
import UnrecoverableError from './UnrecoverableError.vue';
@Options({
  components: { UnrecoverableError },
})
export default class ApplicationErrorNotification extends Vue {
  @Prop() message: string | undefined;
  private get errorMessage(): string {
    const errorMessage = this.message || this.$t('err.application');
    return errorMessage;
  }

  private handleExitTest(): void {
    this.$emit('exitTestClicked');
  }
}
